import { render, staticRenderFns } from "./WorkflowManager.vue?vue&type=template&id=9a8dedfa&scoped=true"
import script from "./WorkflowManager.vue?vue&type=script&lang=js"
export * from "./WorkflowManager.vue?vue&type=script&lang=js"
import style0 from "./WorkflowManager.vue?vue&type=style&index=0&id=9a8dedfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8dedfa",
  null
  
)

export default component.exports